// extracted by mini-css-extract-plugin
export var formTitleFont = "contact-form-module--formTitleFont--1hNDi";
export var labelFont = "contact-form-module--labelFont--cm72T";
export var labelContainer = "contact-form-module--labelContainer--2w2x6";
export var inputContainer = "contact-form-module--inputContainer--2d0zt";